import React from "react";
import { Col, Container, Row } from "reactstrap";

const Home = () => {
  return (
    <React.Fragment>
      <section
        className="section nft-hero auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100"
        id="hero"
        style={{
          background: "rgba(31, 44, 62, 0.9)",
        }}
      >
        <div className="bg-overlay"></div>
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} sm={10}>
              <div className="text-center">
                <h1 className="display-4 fw-medium mb-4 lh-base text-white">
                  Government Request Form{" "}
                </h1>
                <p className="lead text-white-50 lh-base mb-4 pb-2">
                  Government request form used to collect and centralize all
                  government requests made to UN agencies from the Government of
                  Somalia.
                </p>

                <div className="hstack gap-2 justify-content-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      const formSection = document.querySelector(".bg-light");
                      if (formSection) {
                        const navbarHeight = 80; // Account for fixed navbar height
                        const elementPosition =
                          formSection.getBoundingClientRect().top +
                          window.pageYOffset;
                        const offsetPosition = elementPosition - navbarHeight;

                        window.scrollTo({
                          top: offsetPosition,
                          behavior: "smooth",
                        });
                      }
                    }}
                  >
                    Start Filling{" "}
                    <i className="ri-arrow-right-line align-middle ms-1"></i>
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Home;
